import {action, observable, computed} from 'mobx';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';
import {ITranslate} from '../../../../../services/LocalizationService';

export enum SendTextDialogEvents {
    CLOSE = 'CLOSE',
    SEND = 'SEND'
}

export class SendTextDialogController extends TechseeBaseController {
    @observable isVisible: boolean = false;
    @observable text: string = '';
    @observable showNotification: boolean = false;
    @observable isReadonly: boolean = false;
    @observable placeholder: string = '';
    @observable isEndMeeting: boolean = false;

    constructor() {
        super();
    }

    @computed get titleKey(): string {
        return this.isReadonly ? 'SEND_TEXT.VIEW.TITLE_READONLY' : 'SEND_TEXT.VIEW.TITLE';
    }

    @action
    open = (placeholder: string, readonly: boolean, endMeeting: boolean): void => {
        this.placeholder = placeholder;
        this.isReadonly = readonly;
        this.isEndMeeting = endMeeting;
        this.text = placeholder;
        this.showNotification = false;
        this.isVisible = true;
    };

    @action
    close = (): void => {
        this.isVisible = false;
        this.text = '';
        this.showNotification = false;
        this.emit(SendTextDialogEvents.CLOSE);
    };

    @action
    setText = (value: string): void => {
        this.text = value;
        this.showNotification = false;
    };

    @action
    handleOk = (): void => {
        if (!this.text || !this.text.trim()) {
            this.showNotification = true;
            return;
        }

        const textToSend = this.text;
        this.close();
        this.emit(SendTextDialogEvents.SEND, textToSend);
    };
}
